import { Pipe, PipeTransform } from '@angular/core';
import * as momemt from 'moment';
import { ValidationService } from '../providers/validation.service'

@Pipe({
    name: 'propRemainingTerm'
})
export class PropRemainingTermPipe implements PipeTransform {

    constructor(private Validation: ValidationService) { }

    transform(expirationDate: Date, commencementDate: Date): string {
        return this.Validation.getRemainingTerm(expirationDate, commencementDate);
    }
}
